export default __webpack_public_path__ + "images/d53c79b91ad5b5977c78c5c988ee0135.svg";